import { useSelector } from 'react-redux';

import type { FunctionalRootState } from '@share/utils';
import { resolveCertificateClubSiteId } from '@share/utils';

export function useCertificateClubSiteId(): number | undefined {
  const account = useSelector((state: FunctionalRootState) => state.loginStore.account);
  const user = useSelector((state: FunctionalRootState) => state.loginStore.user);
  const menuOrganizationId = useSelector(
    (state: FunctionalRootState) => state.navigationMenuStore.items?.organizationId,
  );

  return resolveCertificateClubSiteId({
    account,
    user,
    menuOrganizationId,
  });
}
